import React from 'react';
import styled, { css } from 'styled-components';
import {
  bool, func, string, number,
} from 'prop-types';
import { Flex, Typography, Circle } from '@atoms';
import { OptionQuantityCounter } from '@molecules';
import { formatPrice } from '@helpers/menuItemDetails';

const ItemOptionValue = ({
  onOptionQuantityDecrement,
  onOptionQuantityIncrement,
  quantity,
  id,
  optionId,
  imageSrc,
  name,
  price,
  isSelected,
  onOptionValueSelect,
  allowValueMultipleSelection,
}) => (
  <Wrapper grow={0} display="inline-flex" wrapFlex column>
    <OptionQuantityCounter
      onOptionQuantityDecrement={onOptionQuantityDecrement}
      onOptionQuantityIncrement={onOptionQuantityIncrement}
      quantity={quantity}
      allowValueMultipleSelection={allowValueMultipleSelection}
      optionId={optionId}
      id={id}
    />
    <ImageFlex
      marginTop="xxs"
      imageSrc={imageSrc}
      className={isSelected && 'selected-value'}
      onClick={onOptionValueSelect(optionId, id)}
      diameter={57}
      selfCenter
      grow={0}
    >
      {allowValueMultipleSelection && (
        <StyledCircle
          backgroundColor="strawberry"
          diameter={18}
          justifyCenter
          itemsCenter
        >
          <Typography color="white" size="sm" weight="black">
            {allowValueMultipleSelection ? 1 : quantity}
          </Typography>
        </StyledCircle>
      )}
    </ImageFlex>
    <StyledTypography size="sm" weight="black" marginTop="sm">
      {name}
      {' '}
      {price > 0 && (
        <Typography as="span" color="strawberry" size="sm" weight="black">
          {`($${formatPrice(price)})`}
        </Typography>
      )}
    </StyledTypography>
  </Wrapper>
);

const Wrapper = styled(Flex)`
  ${({ theme: { spacing, color } }) => css`
    width: 70px;
    text-align: center;
    white-space: normal;

    :not(:first-child) {
      margin-left: ${spacing.md};
    }

    .selected-value {
      border: 4px solid ${color.grannySmith};
    }
  `}
`;

const ImageFlex = styled(Circle)`
  ${({
    imageSrc,
  }) => css`
    background: url(${imageSrc});
    position: relative;
    background-size: cover;
  `}
`;

const StyledTypography = styled(Typography)`
  ${() => css`
    text-overflow: ellipsis;
    overflow: hidden;
    width: 70px;
  `}
`;

const StyledCircle = styled(Circle)`
  ${() => css`
    position: absolute;
    top: -4px;
    left: -4px;
  `}
`;

ItemOptionValue.propTypes = {
  allowValueMultipleSelection: bool.isRequired,
  quantity: number.isRequired,
  onOptionQuantityDecrement: func.isRequired,
  onOptionQuantityIncrement: func.isRequired,
  optionId: number.isRequired,
  id: number.isRequired,
  imageSrc: string.isRequired,
  name: string.isRequired,
  price: number.isRequired,
  isSelected: bool.isRequired,
  onOptionValueSelect: func.isRequired,
};

export default ItemOptionValue;
